
export enum ColumnTypes {
    String = 'string',// default 
    Number = 'number',	
    Date = 'date'	,
    DateTime ='dateTime',
    Boolean = 'boolean',	
    Select ='select',
    Autocomplete = 'autocomplete',
    Actions = 'actions'
} 
